<template>
  <div class="text-center py-24">
    <div class="text-6xl mb-4">404</div>
    <h1 class="text-3xl font-bold mb-2">Page Not Found</h1>
    <p class="text-gray-600 mb-8">The page you're looking for doesn't exist.</p>
    <router-link to="/" class="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
      Back to Home
    </router-link>
  </div>
</template>
